export const settings = {
    baseUrl: import.meta.env.PROD ? location.protocol + '//' + location.host + '/api/' : import.meta.env.VITE_BASE_URL,
    gtag: 'UA-177913153-1',
    stripe_key: import.meta.env.VITE_STRIPE_KEY
}
